import { FC, ReactNode } from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

interface FullScreenLayoutProps {
  children?: ReactNode;
}

// Renders children full-bleed without header or sidebar
const FullScreenLayout: FC<FullScreenLayoutProps> = ({ children }) => {
  return (
    <Box
      sx={{
        flex: 1,
        height: '100vh',
        // NOT 100vw: that includes the vertical scrollbar, so any page taller than
        // the viewport ends up ~15px wider than the visible area and forces a
        // horizontal scrollbar. 100% is the true content width.
        width: '100%',
        maxWidth: '100%',
        transition: 'background-color 0.3s ease, color 0.3s ease'
      }}
    >
      {children || <Outlet />}
    </Box>
  );
};

export default FullScreenLayout;


